import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { Fade } from "react-awesome-reveal";
import MobileSubHeader from '../../components/PageHeader/MobileSubHeader';
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import DataTable from "../../components/Datatable/DataTable";
import * as actions from "../../store/ducks/agent/actions";
import Swal from "sweetalert2";

class MobileDownlineAgent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            limit: 10,
            totalRecords: 0,
            searchValue: '',
            order: '',
            data: [],
            agentDetails: {},
            loading: true,
        }
    }

    componentDidMount() {
        const listingArr = this.getFilterArray();
        this.props.funcDownlineAgent(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.downlineAgent !== this.props.downlineAgent && nextProps.downlineAgent !== undefined) {
            if (nextProps.downlineAgent.responseCode === 200 && nextProps.downlineAgent.msgType === 'success') {
                this.setState({
                    agentDetails: nextProps.downlineAgent.data.agent || {},
                    data: nextProps.downlineAgent.data.result.row,
                    totalRecords: nextProps.downlineAgent.data.result.pagination.total_record,
                    loading: false,
                });
            } else {
                this.setState({
                    agentDetails: {},
                    data: [],
                    totalRecords: 0,
                    activePage: 1,
                    loading: false
                }, () => {
                    if (nextProps.downlineAgent.message) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: nextProps.downlineAgent.message[0] || 'An error occurred',
                        });
                    }
                });
            }
        }

        return true;
    }

    refreshHandler = () => {
        const listingArr = this.getFilterArray();
        this.props.funcDownlineAgent(listingArr);
    }

    getFilterArray = () => {
        const listingArr = {};

        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.id = this.props.currentUser.data.id;

        this.setState({
            loading: true,
            data: [],
        });

        return listingArr;
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({ order: orderArry }, () => {
            this.refreshHandler();
        });
    }

    datatablesChangeHandler = (val, act) => {
        this.setState({
            [act]: (act === 'searchValue') ? val.target.value : val
        }, () => {
            this.refreshHandler();
        });
    }

    render() {
        const { t } = this.props;

        const columns = [
            {
                text: t('global.no'),
                dataField: 'no',
                formatter: (cell, row, rowIndex) => {
                    let rowNumber = ((this.state.activePage - 1) * this.state.limit) + (rowIndex + 1);
                    return <span>{rowNumber}</span>;
                },
                headerStyle: { width: '60px', textAlign: 'center' }
            },
            {
                text: t('management.agent-username'),
                dataField: 'username',
                sort: true,
                onSort: this.onSort,
            },
            {
                text: t('management.share-percentage'),
                dataField: 'percentage',
                sort: true,
                onSort: this.onSort,
                formatter: (cell, row, rowIndex) => {
                    return <span>{row.percentage}%</span>;
                },
            },
        ];

        return (
            <Auxiliary>
                <section className="pf-m-dashboard">
                    <div className='filters-m-col'>
                        <MobileSubHeader
                            className="bg-white"
                            returnPage="/"
                            header={t('sidebar.downline-agents')}
                            style={{ justifyContent: "unset" }}
                        />
                        <div className="pd-m-card-col">
                            <div className="p-3">
                                <h5 className="mb-3">{t('sidebar.agent-details')}</h5>
                                {this.state.loading ? (
                                    <Skeleton count={3} />
                                ) : (
                                    <div className="card-shadow p-3">
                                        <div className="row mb-2">
                                            <div className="col-5">
                                                <label className="fw-bold">{t('management.agent-username')}:</label>
                                            </div>
                                            <div className="col-7">
                                                <span>{this.state.agentDetails.username}</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-5">
                                                <label className="fw-bold">{t('management.referral-code')}:</label>
                                            </div>
                                            <div className="col-7">
                                                <span>{this.state.agentDetails.referral_code}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="p-3">
                                <h5 className="mb-3">{t('sidebar.downline-agents')}</h5>
                                <Fade duration={1000} triggerOnce>
                                    <DataTable
                                        keyField='no'
                                        data={this.state.data}
                                        columns={columns}
                                        activePage={this.state.activePage}
                                        limit={this.state.limit}
                                        totalItems={this.state.totalRecords}
                                        paginationHandler={(val) => this.datatablesChangeHandler(val, 'activePage')}
                                        sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'limit')}
                                        searchChangeHandler={(val) => this.datatablesChangeHandler(val, 'searchValue')}
                                        searchValue={this.state.searchValue}
                                        classValue='pd-table'
                                        loading={this.state.loading}
                                        hideSearchBar={true}
                                        hideTotalRecords={true}
                                        component="downline-agent"
                                    />
                                </Fade>
                            </div>
                        </div>
                    </div>
                </section>
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        downlineAgent: state.agent.downlineAgent,
        currentUser: state.currentUser,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        funcDownlineAgent: (filter) => dispatch(actions.downlineAgent(filter)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MobileDownlineAgent));
